import client, { AuthClient } from "@/utils/client";

export const likeCatalog = (catalogId: string) => {
  return AuthClient().post("/common/like-catalog", { catalogId });
};

export const getFollowers = (userId: any, search: any, page: any) => {
  return AuthClient().post(
    `/common/get-follower?search=${search}&page=${page}`,
    {
      userId,
    }
  );
};

export const removeFollowers = (
  userId: any,
  followingId: any,
  userType: any
) => {
  return AuthClient().delete("/common/remove-follower", {
    data: {
      userId,
      followingId,
      userType,
    },
  });
};
